<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 실시기간 -->
          <c-datepicker
            :range="true"
            defaultStart="-1M"
            defaultEnd="1M"
            label="실시기간"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-field 
            type="user" 
            label="확인자" 
            name="confirmUserId" 
            v-model="searchParam.confirmUserId" />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="소방교육 및 훈련일지 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn label="LBLREG" v-if="editable" icon="add" @btnClicked="openPop" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "fireFightingJournal",
  data() {
    return {
      searchParam: {
        plantCd: null,
        period: [],
        confirmUserId: '',
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "LBLPLANT",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "journalName",
            field: "journalName",
            label: "일지명",
            style: 'width:200px',
            align: "left",
            type: "link",
            sortable: true,
          },
          {
            name: "actionDate",
            field: "actionDate",
            label: "실시일",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "confirmUserName",
            field: "confirmUserName",
            label: "확인자",
            style: 'width:120px',
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.fft.fireFightingJournal.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    openPop() {
      this.linkClick();
    },
    linkClick(row) {
      this.popupOptions.title = "소방교육 및 훈련일지 상세"; // 소방교육 및 훈련일지 상세
      this.popupOptions.param = {
        sopFireFightingJournalId: row ? row.sopFireFightingJournalId : '',
      };
      this.popupOptions.target = () => import(`${"./fireFightingJournalDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
